var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyRupee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4375 15L0.833333 9.16667V7.5H3.75C4.48611 7.5 5.12153 7.26042 5.65625 6.78125C6.19097 6.30208 6.51389 5.70833 6.625 5H0V3.33333H6.375C6.13889 2.84722 5.78819 2.44792 5.32292 2.13542C4.85764 1.82292 4.33333 1.66667 3.75 1.66667H0V0H10V1.66667H7.29167C7.48611 1.90278 7.65972 2.15972 7.8125 2.4375C7.96528 2.71528 8.08333 3.01389 8.16667 3.33333H10V5H8.3125C8.20139 6.18056 7.71528 7.17014 6.85417 7.96875C5.99306 8.76736 4.95833 9.16667 3.75 9.16667H3.14583L8.75 15H6.4375Z",
    fill: "#2A8642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyRupee);
export default __webpack_public_path__ + "static/media/currency_rupee.e85f61f00635476e03cf3833fe7ed250.svg";
export { ForwardRef as ReactComponent };